import React from "react";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import {
  Circle,
  HoverEffect,
  ProjectCells,
  ProjectImage,
} from "../styles/projectTab";
import { LinearLine } from "../styles/porfolio";

export const ProjectCard = ({ link, image, title, subtitle }) => {
  return (
    <ProjectCells>
      <HoverEffect href={link} target="_blank">
        <Circle>
          <ArrowOutwardIcon style={{ color: "white" }} />
        </Circle>
      </HoverEffect>
      <ProjectImage
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
        }}
      />
      <h3>{subtitle}</h3>
      <LinearLine></LinearLine>
      <p>{title}</p>
    </ProjectCells>
  );
};
